<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height"
			@show="modal_onshow" show-footer @hide="modal_onhide" destroy-on-close :loading="loading">
			<template #default>
				<div style="padding: 20px;" v-if="formShow">
					<el-form ref="form" :model="form" label-width="50px">
						<el-form-item label="编码" size="mini" required>
							<el-input v-model="code"></el-input>
						</el-form-item>
						<el-form-item label="名称" size="mini" required>
							<el-input v-model="name"></el-input>
						</el-form-item>
						<el-form-item label="类型" size="mini" required>
							<el-radio-group v-model="config.type">
								<el-radio label="add">新增</el-radio>
								<el-radio label="update">更新</el-radio>
								<el-radio label="addupdate">新增并更新</el-radio>
							</el-radio-group>
						</el-form-item>
						<template v-for="(item,index) in field">
							<el-divider content-position="left" :key="index">{{tablemap[index]}}</el-divider>
							<template v-for="(_item,_index) in item">
								<div class="flex"
									style="flex-direction: row;align-items: center;margin: 20px 10px;justify-content: space-between;"
									:key="index+_index">
									<el-switch style="margin-right: 20px;" v-model="form[index+'|'+_item.field].enable"
										:active-text="_item.title + '【'+_item.field+'】'" @change="enableChange(index+'|'+_item.field)"
										:active-value="'1'" :inactive-value="'0'"></el-switch>
									<el-checkbox-group v-model="form[index+'|'+_item.field].config"
										@change="configChange(index+'|'+_item.field)">
										<el-checkbox label="require" name="config">必填</el-checkbox>
										<el-checkbox label="unique" name="config">唯一值</el-checkbox>
									</el-checkbox-group>
								</div>

							</template>
						</template>
					</el-form>
				</div>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
				<vxe-button status="primary" content="保存" @click="submit"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [modalMixins],
		props: {
			data: {
				default: () => {
					return []
				}
			},
			row: {
				default: () => {
					return null
				}
			},
			formid: {
				default: () => {
					return 0
				}
			},
		},
		data() {
			return {
				loading:false,
				formShow: false,
				modal_model: false,
				modal_title: '新增导入配置',
				modal_width: 600,
				modal_height: 800,
				code: null,
				name: null,
				config: {
					type: null
				},
				tablemap: {},
				field: [],
				form: {},

				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {

		},
		methods: {
			modal_init() {
				this.formShow = false
				this.initform().then((form) => {
					if (this.row) {
						form = {
							...form,
							...this.row.json
						}
						this.code = this.row.code
						this.name = this.row.name
						this.config = this.row.config
					}
					this.form = form
					this.formShow = true
				})

			},
			initform() {
				this.code = null
				this.name = null
				this.config = {
					type: null
				}
				this.tablemap = {}
				this.field = []
				this.form = {}
				return new Promise((reslove) => {
					this.$api.form.get(this.formid).then((res) => {
						//console.log(res)
						let rule = res.rule.rule
						let field = []
						let form = {}
						rule.forEach((item) => {
							//console.log(item)
							let obj = {}
							if (item.field) {
								if (!item.field.startsWith('$son_')) {
									if (item.field) {
										obj.tabletype = 'main'
										obj.tablename = '主表'
										obj.tablecode = 'main'
										obj.field = item.field
										obj.title = item.title
										obj.type = item.type
										obj.props = item.props
									}
									field.push(obj)
								} else {
									item.props.fields.forEach((_item) => {
										obj = {}
										if (_item.field) {
											obj.tabletype = 'son'
											obj.tablename = item.tablename
											obj.tablecode = item.field.replace('$son_',
												'')
											obj.field = _item.field
											obj.title = _item.title
											obj.type = _item.type
											obj.props = _item.props
										}
										field.push(obj)
									})
								}
							}

						})
						field = this.$Lodash.groupBy(field, 'tablecode')
						for (let i in field) {
							this.tablemap[i] = field[i][0].tablename
							field[i].forEach((item) => {
								form[i + '|' + item.field] = {
									config: [],
									enable: 0
								}
							})
						}
						this.field = field
						reslove(form)
					})
				})
			},
			enableChange(e) {
				if (this.form[e].enable == '0') {
					this.form[e].config = []
				}
			},
			configChange(e) {
				console.log(this.form[e])
				if (this.form[e].config.length) {
					this.form[e].enable = '1'
				}
			},
			submit() {
				this.loading = true
				let form = {}
				for (let i in this.form) {
					if (this.form[i].enable === '1') {
						form[i] = this.form[i]
					}
				}					
				if (!this.row) {
					this.$api.formconfig.save({
						formid: this.formid,
						json: form,
						config: this.config,
						code: this.code,
						name: this.name,
						type: 'import'
					}).then(() => {
						this.loading = false
						this.$emit('success')
						this.modal_cancel()
					},()=>{
						this.loading = false
					})
				} else {
					this.$api.formconfig.update(this.row.id, {
						formid: this.formid,
						json: form,
						config: this.config,
						code: this.code,
						name: this.name,
						type: 'import'
					}).then(() => {
						this.loading = false
						this.$emit('success')
						this.modal_cancel()
					},()=>{
						this.loading = false
					})
				}

			},
			reset() {
				//this.init()
			}
		},
		components: {

		}
	}
</script>